import {useEffect, useState} from "react";
import {useDeepCompareEffect} from "@/hooks/useDeepCompareEffect";

type UseServerActionOptions<T> = {
    queryFn: () => Promise<T>;
    queryKey: any[];
    enabled?: boolean;
    interval?: number;
};

export function useQuery<T>({ queryFn, queryKey, enabled = true, interval }: UseServerActionOptions<T>) {
    const [data, setData] = useState<T>();
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<Error | null>(null);

    const fetchData = async () => {
        setIsLoading(true);
        setError(null);
        try {
            const result = await queryFn();
            setData(result);
        } catch (err) {
            setError(err as Error);
        } finally {
            setIsLoading(false);
        }
    };

    useDeepCompareEffect(() => {
        if(!enabled) return;

        fetchData();
    }, [queryKey, enabled]);

    useEffect(() => {
        if(!interval || !enabled) return;

        const handleVisibilityChange = () => {
            if(document.hidden) {

            } else {
                fetchData();
            }
        }

        document.addEventListener("visibilitychange", handleVisibilityChange);

        const intervalFetch = setInterval(() => {
            if(!document.hidden) {
                fetchData();
            }
        }, interval)

        return () => {
            clearInterval(intervalFetch);
            document.removeEventListener("visibilitychange", handleVisibilityChange)
        }
    }, [interval, enabled])

    return { data, isLoading, error };
}